<template>
  <component :is="el" :label="label" :prop="prop" :required="required">

    <el-input-number
    v-if="!disabled"
    v-model="formData"
    :step="step"
    :min="min"
    :max="max"
    :size="size"
    :disabled="disabled"
    :placeholder="placeholder"
    :required="required"
    @change="updated">
    </el-input-number>
    <span v-else>
      <span v-if="prefix"><i v-if="isPrefixIcon" :class="prefix"></i><span v-else v-html="prefix"></span></span>
      <b>{{this.formatNumber(this.formData, this.decimals)}}</b>
      <span v-if="suffix" slot="label"><i v-if="isSuffixIcon" :class="suffix"></i><span v-else v-html="suffix"></span></span>
    </span>
  </component>
</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'

export default {
  name: 'number-input',

  mixins: [NumberMixins],

  props: {

    label: {
      type: String,
      default: null
    },

    value: {
//      type: Number,
      required: true
    },

    step: {
      type: Number,
      default: 1
    },

    min: {
      type: Number
    },

    max: {
      type: Number
    },

    size: {
      type: String,
      default: 'default'
    },

    decimals: {
      type: Number,
      default: 0
    },

    prefix: {
      type: String,
      default: null
    },

    suffix: {
      type: String,
      default: null
    },

    isPrefixIcon: {
      type: Boolean,
      default: false
    },

    isSuffixIcon: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    prop: {
      type: String,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },


  methods: {

    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  watch: {
    value: function (val) {
      this.formData = val
    }
  },


  data () {
    return {
      el: this.noForm ? 'div' : 'el-form-item',
      formData: this.value
    }
  }

}
</script>

<style scoped>
input {
  float: right;
  clear: both;
}
</style>



// WEBPACK FOOTER //
// NumberInput.vue?e2bfab90